import Moment from "moment";
import { extendMoment } from "moment-range";

const moment = extendMoment(Moment);

const date = [
  {
    open: "2026-10-01",
    close: "2026-12-31",
    test: "2027-01-02",
    result: "2027-01-11",
    daftarUlang: "12 - 19 Januari 2027",
    wave: 1,
  },
  {
    open: "2027-01-22",
    close: "2027-04-08",
    test: "2027-04-10",
    result: "2027-04-19",
    daftarUlang: "20 - 27 April 2027",
    wave: 2,
  },
  {
    open: "2030-06-12",
    close: "2030-06-17",
    test: "2030-06-19",
    result: "2030-06-23",
    daftarUlang: "-",
    wave: 3,
  },
  {
    open: "2040-07-01",
    close: "2040-07-01",
    test: "2040-07-01",
    result: "2040-07-01",
    daftarUlang: "-",
    wave: 4,
  },
];

export default function auth({ next, router }) {
  moment.locale("id");

  const currentTime = moment(localStorage.getItem("date"));

  const currentWave = date.filter((itemDate) => {
    const range = moment().range(moment(itemDate.open), moment(itemDate.close));
    return range.contains(currentTime);
  });

  if (currentWave.length <= 0)
    return router.push({
      name: "home",
    });

  return next();
}
